export function headerNavLocation(state = null, action) {
  switch (action.type) {
    case 'HEADER_NAV_LOCATION':
      return action.navLocation;
    default:
      return state;
  }
}

export function headerNavStyle(state = null, action) {
  switch (action.type) {
    case 'HEADER_STYLE':
      return action.headerStyle;
    default:
      return state;
  }
}

export function menuState(state = false, action) {
  switch (action.type) {
    case 'MENU_STATE':
      return action.bool;
    default:
      return state;
  }
}

export function slugState(state = false, action) {
  switch (action.type) {
    case 'SLUG_STATE':
      return action.route;
    default:
      return state;
  }
}

export function routerState(state = false, action) {
  switch (action.type) {
    case 'ROUTER_STATE':
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/header_nav_location.js